/** Normalizes resource ids for stable TanStack Query cache keys. */
export function normalizeResourceIds(
  resourceIds: readonly number[]
): number[] {
  return [...new Set(resourceIds.filter((id) => id > 0))].sort(
    (left, right) => left - right
  );
}

/** Cache key segment for a list of resource ids. */
export function getResourceIdsKey(resourceIds: readonly number[]): string {
  return normalizeResourceIds(resourceIds).join(',');
}
